import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-wait',
  templateUrl: './wait.component.html',
  styleUrls: ['./wait.component.scss']
})
export class WaitComponent implements OnInit {

  headline: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: WaitComponentInputData) {
    if(data){
      if(data.headline) this.headline = data.headline;
    }
  }

  ngOnInit(): void {
  }

}

export class WaitComponentInputData {
  headline: string;
}
